import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
//coontainers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//components
import Video from '../components/video/Video';
import Logo from '../components/logo/Logo';
import InteractiveMap from '../components/interactivemap/InteractiveMap';
import IndustrySmall from '../components/industry/IndustrySmall';
// import SignupButton from '../components/signupbutton/SignupButton';
import QuoteCarousel from '../components/quote-carousel/quote-carousel';
//css
import 'bootstrap/dist/css/bootstrap.css';
import '../page-layout.styl';
import './landing.styl';
//text
import { LandingPageText as LandingPageTextEN, VacancyText as VacancyTextEN, Quotes as QuotesEN } from '../input-text/en/landing_page';
import { LandingPageText as LandingPageTextNL, VacancyText as VacancyTextNL, Quotes as QuotesNL  } from '../input-text/nl/landing_page';
//require images by their paths;
import author_image_2 from '../media/author_img_2.jpg';
import author_image_3 from '../media/author_img_3.jpg';
import author_image_4 from '../media/author_img_4.png';
import 'react-select/dist/react-select.css';
import DemoSection from "../components/demosection/DemoSection";

class Landing extends React.Component {
    constructor(){
        super();
        const images = [author_image_2, author_image_3, author_image_4];
        //image one removed due to author's request
        //const images = [author_image_1, author_image_2];
        //attach images to quotes
        QuotesEN.forEach(quote => {
            quote.image = images[QuotesEN.indexOf(quote)];
        });
        QuotesNL.forEach(quote => {
            quote.image = images[QuotesNL.indexOf(quote)];
        });
        this.setLocale = this.setLocale.bind(this);
    }

    componentWillMount() {
        switch (this.props.lang) {
            case 'nl':
                this.props.setLocale(this.props.lang, true);
                break;
            default: this.props.setLocale(this.props.locale, true);
        }
    }

    componentWillUnmount() {
        this.props.setLocale(this.props.locale, false);
    }

    setLocale(locale) {
        this.LandingPageText = null;
        this.Quotes = null;
        switch (this.props.locale) {
            case 'en':
                this.LandingPageText = LandingPageTextEN;
                this.VacancyText = VacancyTextEN;
                this.Quotes = QuotesEN;
                break;
            case 'nl':
                this.LandingPageText = LandingPageTextNL;
                this.VacancyText = VacancyTextNL;
                this.Quotes = QuotesNL;
                break;
            default:
                this.LandingPageText = LandingPageTextEN;
                this.VacancyText = VacancyTextEN;
                this.Quotes = QuotesEN;
        }
    }

    render(){
        this.setLocale(this.props.locale)

        return (
            <div>
                <Video />
                {/*
                <section className="page-section page-section--primary page-section--thin">
                    <div className="container">
                        <div className="landing-page__vacancy">
                            <div dangerouslySetInnerHTML={{ __html: this.VacancyText.text }}></div>
                            <a className="button" href={ this.VacancyText.link } target="_blank">{ this.VacancyText.cta }</a>
                        </div>
                    </div>
                </section>
                */}
                <SimpleContainer color='white' containerClass='info-strip padded-container'>
                    <h1><span className='highlight'>{this.LandingPageText._1}</span>{this.LandingPageText._2}</h1>
                </SimpleContainer>
                <SimpleContainer color='white' containerClass='description title interactive-map-container-outer padded-container'>
                    <div className='hidden-lg outside-logo'>
                        <Logo ver='unfolded' size='large' />
                    </div>
                    <div className='col-xs-12 col-md-5 col-lg-6 interactive-map-text-container'>
                        <div className='col-xs-12 visible-lg inline-logo'>
                            <Logo ver='unfolded' size='large' />
                        </div>
                        <div className='col-md-12 col-xs-7 description-text highlight'>
                            <h1><span>{this.LandingPageText._3}</span></h1>
                        </div>
                        <div className='col-xs-12 col-sm-5 col-md-12 description-bullets'>
                            <ul>
                                <li><h2>{this.LandingPageText._4}</h2></li>
                                <li><h2>{this.LandingPageText._5}</h2></li>
                                <li><h2>{this.LandingPageText._6}</h2></li>
                            </ul>
                        </div>
                    </div>
                    <InteractiveMap />
                </SimpleContainer>
                <SimpleContainer color='light' containerClass='industries-container padded-container'>
                    <h1>{this.LandingPageText._7}</h1>
                    <NavLink to="/industries/homeandoffice">
                        <IndustrySmall industry='ho' />
                    </NavLink>
                    <NavLink to="/industries/info">
                        <IndustrySmall industry='info' />
                    </NavLink>
                    <NavLink to="/industries/outdoor">
                        <IndustrySmall industry='outdoor' />
                    </NavLink>
                    <NavLink to="/industries/health">
                        <IndustrySmall industry='health' />
                    </NavLink>
                    <NavLink to="/industries/auto">
                        <IndustrySmall industry='auto' />
                    </NavLink>
                    <NavLink to="/industries/intelli">
                        <IndustrySmall industry='intelli' />
                    </NavLink>
                </SimpleContainer>
{/*                <SimpleContainer color='white' containerClass='signup-strip padded-container'>
                    <h1>{this.LandingPageText._8}</h1>
                    <p className='signup-text'>{this.LandingPageText._9}</p>
                    <SignupButton />
                </SimpleContainer>*/}
                <SimpleContainer id="demo" color='white' containerClass='signup-strip padded-container'>
                    <h1>{this.LandingPageText._10}</h1>
                    <DemoSection/>
                </SimpleContainer>
                <section className="page-section">
                    <div className="container">
                        <QuoteCarousel quotes={ this.Quotes } />
                    </div>
                </section>
            </div>


        );
    }
}

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale, hasTranslation) => dispatch({
      type: 'UPDATE_LOCALE',
      locale,
      hasTranslation,
    }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing);




// WEBPACK FOOTER //
// ./src/routes/Landing.js